export const RENAME_CLASS_REQUEST = 'NEW_YEAR_MODAL.RENAME_CLASS_REQUEST';
export const RENAME_CLASS_SUCCESS = 'NEW_YEAR_MODAL.RENAME_CLASS_SUCCESS';
export const RENAME_CLASS_ERROR = 'NEW_YEAR_MODAL.RENAME_CLASS_ERROR';
export const ARCHIVE_CLASS_REQUEST = 'NEW_YEAR_MODAL.ARCHIVE_CLASS_REQUEST';
export const ARCHIVE_CLASS_SUCCESS = 'NEW_YEAR_MODAL.ARCHIVE_CLASS_SUCCESS';
export const ARCHIVE_CLASS_ERROR = 'NEW_YEAR_MODAL.ARCHIVE_CLASS_ERROR';
export const ACTUALIZE_CLASS_REQUEST = 'NEW_YEAR_MODAL.ACTUALIZE_CLASS_REQUEST';
export const ACTUALIZE_CLASS_SUCCESS = 'NEW_YEAR_MODAL.ACTUALIZE_CLASS_SUCCESS';
export const ACTUALIZE_CLASS_ERROR = 'NEW_YEAR_MODAL.ACTUALIZE_CLASS_ERROR';
export const CLOSE_MODAL = 'NEW_YEAR_MODAL.CLOSE_MODAL';
export const SET_PAGE = 'NEW_YEAR_MODAL.SET_PAGE';
export const SET_NEW_NAME = 'NEW_YEAR_MODAL.SET_NEW_NAME';
export const SET_NEW_LEVEL = 'NEW_YEAR_MODAL.SET_NEW_LEVEL';
export const CLEAR_STATE = 'NEW_YEAR_MODAL.CLEAR_STATE';
export const ARCHIVE_TEAM = 'NEW_YEAR_MODAL.ARCHIVE_TEAM';
export const RENAME_TEAM = 'NEW_YEAR_MODAL.RENAME_TEAM';
